import { useQuery } from "@tanstack/react-query";

const getToken = async () => {
  const response = await fetch("/api/get-token");
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data: { hasToken: boolean } = await response.json();
  return data;
};

export const useGetToken = () => {
  return useQuery({
    queryKey: ["getToken"],
    queryFn: getToken,
  });
};
